/**
 * HUD — US 01.07: health always visible, plus money, plus the day counter
 * (US 03.06). Pure DOM, fed by the 'client-state' and 'city-info' bus
 * events; renders nothing until the first sync.
 */
import { worldBus } from '@shared/bus.js';
import { progressBar } from './design/components.js';

export function initHud(root: HTMLElement): void {
  const hud = document.createElement('div');
  hud.className = 'wca-hud hidden';
  root.appendChild(hud);

  let vitals: { money: number; health: number } | null = null;
  let day: { day: number; daysUntilCutover: number | null } | null = null;

  function render(): void {
    if (!vitals) return;
    hud.classList.remove('hidden');
    hud.innerHTML = '';
    const line = document.createElement('span');
    const dayText = day
      ? `   Day ${day.day + 1}${day.daysUntilCutover !== null ? ` · ${day.daysUntilCutover}d left` : ''}`
      : '';
    line.textContent = `❤ ${vitals.health}   ⛃ ${vitals.money}${dayText}`;
    hud.append(line, progressBar(vitals.health, 100));
    hud.classList.toggle('wca-hud-low', vitals.health <= 25);
  }

  worldBus.on('client-state', ({ money, health }) => {
    vitals = { money, health };
    render();
  });
  worldBus.on('city-info', ({ dayInfo }) => {
    day = dayInfo;
    render();
  });
}
